/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const caracteristiqueSchema = z.object({
      "nbPieces": z.number().int().describe("Nombre de pièces").optional(),
  "nbChambres": z.number().int().describe("Nombre de chambres").optional(),
  "surfaceHabitable": z.number().describe("Surface habitable").optional(),
  "surfaceTerrain": z.number().describe("Surface du terrain").optional(),
  "typeChauffage": z.array(z.string()).describe("Liste de types de chauffage").optional()
      })